import React, { useEffect, useState } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import { TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Autocomplete } from '@material-ui/lab';
import MenuItem from '@material-ui/core/MenuItem';
import { useStyles } from './styles';

const initialSearch = {
  ciudad: null,
  estado: '',
  impulsa: '',
  estrategia: null,
  departamento: null,
  establecimientoVehiculos: null,
};
const SearchFilterSocios = (props) => {
  const {
    vertical,
    lineas,
    ciudades,
    handleChange,
    departamentos,
    controlComponent,
    handleChangeDepartment,
  } = props;

  const classes = useStyles();
  const [searchControl, setSearchControl] = useState(initialSearch);

  


  useEffect(() => {
    setSearchControl(initialSearch);
  }, [controlComponent]);

  const filterOptions = (options) =>
    vertical === "TVS" ? options.filter((option) => option.marca === "TVS") : options;

  return (
    <>
      <div className={classes.contentSearch}>
        <FormControl className={classes.formControl}>
          <Autocomplete
            noOptionsText="Sin opciones"
            value={searchControl.departamento}
            options={departamentos}
            getOptionLabel={(option) => option.NOMBRE_DPT}
            renderInput={(params) => (
              <TextField {...params} label="Departamento" />
            )}
            onChange={(e, newVal) => {
              const choose = newVal ? newVal.NOMBRE_DPT : null;
              setSearchControl({
                ...searchControl,
                departamento: newVal,
                ciudad: null,
              });
              handleChangeDepartment('departamento', choose);
            }}
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <Autocomplete
            noOptionsText="Sin opciones"
            value={searchControl.ciudad}
            options={ciudades}
            getOptionLabel={(option) => option.NOMBRE_MPI}
            renderInput={(params) => (
              <TextField {...params} label="Ciudad" />
            )}
            onChange={(e, newVal) => {
              const choose = newVal ? newVal.NOMBRE_MPI : null;
              setSearchControl({
                ...searchControl,
                ciudad: newVal,
              });
              handleChange('ciudad', choose);
            }}
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <Autocomplete
            noOptionsText="Sin opciones"
            value={searchControl.linea}
            options={lineas}
            getOptionLabel={(option) => option.linea}
            filterOptions={filterOptions} // Aplica el filtro a las opciones
            renderInput={(params) => (
              <TextField {...params} label="Linea" />
            )}
            onChange={(e, newVal) => {
              const choose = newVal ? newVal.linea : null;
              setSearchControl({
                ...searchControl,
                marca: newVal,
              });
              handleChange('linea', choose);
            }}
          />
        </FormControl>

        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="socio-native-simple">Tiene Impulsa?</InputLabel>
          <Select
            value={searchControl.impulsa}
            className={classes.selectSearch}
            onChange={(e) => {
              setSearchControl({ ...searchControl, impulsa: e.target.value });
              handleChange('impulsa', e.target.value);
            }}
            inputProps={{
              name: 'socio',
              id: 'socio-native-simple',
            }}
          >
            <MenuItem value={null}>
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="SI">Si</MenuItem>
            <MenuItem value="NO">No</MenuItem>
          </Select>
        </FormControl>

        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="socio-native-simple">Estado</InputLabel>
          <Select
            value={searchControl.estado}
            className={classes.selectSearch}
            onChange={(e) => {
              setSearchControl({ ...searchControl, estado: e.target.value });
              handleChange('estado', e.target.value);
            }}
            inputProps={{
              name: 'estado',
              id: 'socio-native-simple',
            }}
          >
            <MenuItem value={null}>
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="SI">Activo</MenuItem>
            <MenuItem value="NO">Inactivo</MenuItem>
          </Select>
        </FormControl>

        <br />
      </div>
    </>
  );
};

export default SearchFilterSocios;
